export class CodewordChangeRequest {
    user: string;
    s_ins: number;
    tp: string;
    code: string;
    ix: number;
    exp_date: string;

    constructor(
    user: string,
    s_ins: number,
    tp: string,
    code: string,
    ix: number,
    exp_date: string
     ){
        this.user = user;
        this.s_ins = s_ins;
        this.tp = tp;
        this.code = code;
        this.ix = ix;
        this.exp_date = exp_date;
    }
}